
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniaonrentinpuneforfamily() {



    const cardData =
    {
        keyword: 'Urbania on rent in Pune for family Trip   ',
        heading: 'Amruta Travels: Urbania on rent in Pune for family Trip  ',
        headingDescription: 'Amruta Travels offers Urbania on Rent in Pune for Family Trips, providing a comfortable and spacious travel solution for families looking to explore nearby destinations or enjoy weekend getaways. Our 13-seater and 17-seater Force Urbania vans come with air-conditioning, modern interiors, and ample seating for a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures your family trip in Pune is safe, convenient, and full of comfort and style..',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania on rent in Pune for family trip",
    "description": "Book Urbania on rent in Pune for a comfortable and enjoyable family trip. Spacious interiors, AC comfort, cushioned seating, luggage space, and professional drivers ensure a smooth journey for families traveling within Pune or for outstation trips like Lonavala, Mahabaleshwar, or Shirdi."
  },
  {
    "name": "Force Urbania for family trip Pune",
    "description": "Hire Force Urbania for a family trip in Pune for safe, luxury, and hassle-free travel. Vehicles are fully AC-equipped, with comfortable seating, ample luggage space, and experienced drivers for a relaxed journey for all family members."
  },
  {
    "name": "Urbania family trip rental Pune",
    "description": "Urbania family trip rental in Pune for small or medium family groups. AC interiors, spacious cushioned seats, luggage-friendly, and professional chauffeurs make your city tour or outstation family outing enjoyable and stress-free."
  },
  {
    "name": "Urbania van hire Pune for family travels",
    "description": "Urbania van hire in Pune for family travels offers comfort, safety, and luxury. Ideal for weekend getaways, temple visits, and leisure trips with AC interiors, cushioned seating, ample luggage space, and professional drivers."
  },
  {
    "name": "Force Urbania on rent Pune for family",
    "description": "Book Force Urbania on rent in Pune for family travel to Lonavala, Mahabaleshwar, Shirdi, or Mumbai. Fully AC, luxury interiors, spacious seating, luggage-friendly, and driven by expert drivers for a safe and comfortable journey."
  },
  {
    "name": "Urbania family tour cab Pune",
    "description": "Urbania family tour cab in Pune for city tours or outstation family trips. Vehicles equipped with AC, cushioned seating, ample luggage space, and professional drivers to make every family outing smooth and enjoyable."
  },
  {
    "name": "13 seater Urbania for family trip Pune",
    "description": "13 seater Urbania for family trips in Pune. Perfect for small to medium families with AC comfort, spacious interiors, cushioned seats, luggage-friendly design, and professional drivers for safe and enjoyable travel."
  },
  {
    "name": "17 seater Urbania for family trip Pune",
    "description": "17 seater Urbania for large family trips in Pune. AC interiors, cushioned seating, ample luggage space, professional drivers, and smooth ride for group family outings, weekend getaways, or pilgrimages."
  },
  {
    "name": "Luxury Urbania for family trip Pune",
    "description": "Luxury Urbania for family trips in Pune with premium interiors, fully AC, spacious cushioned seating, luggage space, and professional drivers ensuring a safe, comfortable, and enjoyable journey."
  },
  {
    "name": "AC Urbania van for family travel Pune",
    "description": "AC Urbania van for family travel in Pune. Ideal for city travel, airport transfers, or outstation trips. Comfortable cushioned seating, ample luggage space, AC interiors, and professional drivers for a stress-free family journey."
  },
  {
    "name": "Urbania with driver for family trip Pune",
    "description": "Urbania with driver for family trips in Pune. Professional chauffeurs, AC comfort, cushioned seating, and luggage-friendly interiors ensure smooth city tours, weekend trips, and long-distance family outings."
  },
  {
    "name": "Urbania on rent for family trip in Baner Pune",
    "description": "Urbania on rent in Baner Pune for family trips. Spacious interiors, AC comfort, cushioned seating, luggage space, and expert drivers provide safe and comfortable travel for family outings, city tours, or outstation trips."
  },
  {
    "name": "Urbania family trip hire Kharadi Pune",
    "description": "Urbania family trip hire in Kharadi Pune for comfortable city and outstation travel. AC-equipped, cushioned interiors, luggage-friendly, and professional drivers ensure enjoyable family journeys."
  },
  {
    "name": "Urbania on rent for family travel Hadapsar",
    "description": "Urbania on rent in Hadapsar for family travel within Pune or for outstation trips. AC interiors, spacious seating, luggage space, cushioned comfort, and professional drivers for stress-free family trips."
  },
  {
    "name": "Urbania family trip rental Hinjewadi Pune",
    "description": "Urbania family trip rental in Hinjewadi Pune for small and medium families. Vehicles come with AC, cushioned seating, luggage-friendly interiors, and experienced drivers for city tours, weekend getaways, or long-distance family travel."
  },
  {
    "name": "Urbania on rent for family trip Wakad Pune",
    "description": "Urbania on rent in Wakad Pune for family trips, weekend getaways, and city travel. Comfortable AC interiors, cushioned seating, luggage space, and professional drivers ensure a smooth journey."
  },
  {
    "name": "Urbania family tour van Kothrud Pune",
    "description": "Urbania family tour van in Kothrud Pune for group family outings. AC interiors, cushioned seating, luggage space, and professional drivers make city tours and outstation family travel comfortable and safe."
  },
  {
    "name": "Urbania on rent in Pimpri Chinchwad for family trip",
    "description": "Urbania on rent in Pimpri Chinchwad for family trips. Ideal for city travel or outstation excursions with AC, cushioned seating, ample luggage space, and professional drivers ensuring comfort and safety."
  },
  {
    "name": "Force Urbania family trip PCMC",
    "description": "Force Urbania family trip service in PCMC for safe and comfortable travel. AC interiors, cushioned seating, luggage-friendly, and experienced drivers make family outings and long-distance trips enjoyable."
  },
  {
    "name": "Urbania family travel hire Pimpri",
    "description": "Urbania family travel hire in Pimpri for city travel or outstation trips. Comfortable AC interiors, spacious cushioned seating, luggage-friendly, and professional drivers ensure smooth and stress-free family travel."
  },
  {
    "name": "Urbania on rent Chinchwad for family trip",
    "description": "Urbania on rent in Chinchwad for family trips with AC comfort, cushioned seating, luggage-friendly interiors, and professional drivers. Perfect for weekend getaways, pilgrimages, or city tours."
  },
  {
    "name": "Urbania family trip van Wakad PCMC",
    "description": "Urbania family trip van in Wakad PCMC with AC interiors, cushioned seating, luggage space, and professional drivers for safe, comfortable, and enjoyable family outings."
  },
  {
    "name": "Urbania family tour cab Nigdi",
    "description": "Urbania family tour cab in Nigdi Pune for city or outstation travel. AC, cushioned seating, luggage-friendly interiors, and professional drivers ensure smooth and stress-free family trips."
  },
  {
    "name": "Pune to Lonavala Urbania family trip",
    "description": "Book Urbania from Pune to Lonavala for a family trip with AC interiors, cushioned seating, luggage space, and professional drivers. Enjoy scenic routes, comfortable travel, and a memorable family experience."
  },
  {
    "name": "Pune to Mahabaleshwar Urbania family tour",
    "description": "Pune to Mahabaleshwar Urbania family tour with fully AC interiors, cushioned seating, luggage-friendly space, professional drivers, and smooth rides for a comfortable family journey."
  },
  {
    "name": "Pune to Shirdi Urbania family trip",
    "description": "Urbania family trip from Pune to Shirdi for pilgrimage and group travel. Spacious AC interiors, cushioned seating, luggage space, and professional drivers ensure a safe, comfortable, and memorable journey for the family."
  }
],
"tableData": [
  ["Urbania on rent in Pune for family trip", "Force Urbania for family trip Pune"],
  ["Urbania family trip rental Pune", "Urbania van hire Pune for family travels"],
  ["Force Urbania on rent Pune for family", "Urbania family tour cab Pune"],
  ["13 seater Urbania for family trip Pune", "17 seater Urbania for family trip Pune"],
  ["Luxury Urbania for family trip Pune", "AC Urbania van for family travel Pune"],
  ["Urbania with driver for family trip Pune", "Urbania on rent for family trip in Baner Pune"],
  ["Urbania family trip hire Kharadi Pune", "Urbania on rent for family travel Hadapsar"],
  ["Urbania family trip rental Hinjewadi Pune", "Urbania on rent for family trip Wakad Pune"],
  ["Urbania family tour van Kothrud Pune", "Urbania on rent in Pimpri Chinchwad for family trip"],
  ["Force Urbania family trip PCMC", "Urbania family travel hire Pimpri"],
  ["Urbania on rent Chinchwad for family trip", "Urbania family trip van Wakad PCMC"],
  ["Urbania family tour cab Nigdi", "Pune to Lonavala Urbania family trip"],
  ["Pune to Mahabaleshwar Urbania family tour", "Pune to Shirdi Urbania family trip"]
],




"whychoose": [
  {
    "WhyChooseheading": "Spacious Urbania for Family Trips",
    "WhyChoosedescription": "Amruta Travels offers Urbania on Rent in Pune for family trips, providing a comfortable, stylish, and safe travel experience for small to medium-sized families."
  },
  {
    "WhyChooseheading": "Perfect for Family Outings and Vacations",
    "WhyChoosedescription": "Whether it’s a city tour, weekend getaway, or a long vacation, renting an Urbania ensures that your family travels together in comfort and style."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Equipped Interiors",
    "WhyChoosedescription": "The Urbania features plush seating, ample legroom, air conditioning, wide windows, and generous luggage space, making it perfect for family journeys of any distance."
  },
  {
    "WhyChooseheading": "Professional and Friendly Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure a safe, smooth, and stress-free journey. They are courteous, punctual, and well-trained to handle family travel needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Affordable Luxury",
    "WhyChoosedescription": "Enjoy the comfort of the Urbania at competitive rates. Amruta Travels provides upfront pricing with no hidden charges, making it an excellent choice for family trips."
  },
  {
    "WhyChooseheading": "Regularly Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All Urbania vehicles are regularly serviced and sanitized, ensuring the highest standards of hygiene, safety, and comfort for your family journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We offer flexible pickup and drop-off options, as well as customized travel routes to match your family’s itinerary and travel plan."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania for a family trip in Pune is simple. Our support team assists you at every step, ensuring a seamless and enjoyable travel experience for your family."
  }
]

    }

const faqData = [
  {
    question: 'How can I rent an Urbania for a family trip in Pune?',
    answer: 'Renting an Urbania for a family trip is easy with Amruta Travels. You can book online, call our support team, or visit our office. We will help you choose the right vehicle based on your family size and travel needs.'
  },
  {
    question: 'What makes the Urbania ideal for family trips?',
    answer: 'The Urbania offers spacious seating, air conditioning, large windows, ample luggage space, and comfortable interiors, making it perfect for family outings, vacations, and long journeys.'
  },
  {
    question: 'Is the Urbania suitable for long-distance family trips?',
    answer: 'Yes, the Urbania is ideal for both local and long-distance travel. It ensures comfort, stability, and safety for your family throughout the journey.'
  },
  {
    question: 'Does the rental include a driver?',
    answer: 'Yes, every Urbania rental for family trips comes with a professional and courteous driver who ensures a smooth, safe, and stress-free journey.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained for family travel?',
    answer: 'Absolutely. All our Urbania vehicles are regularly serviced, cleaned, and maintained to provide maximum safety, hygiene, and comfort for your family.'
  },
  {
    question: 'What is the cost of renting an Urbania for a family trip in Pune?',
    answer: 'The rental cost depends on trip duration, distance, and any additional services. Contact Amruta Travels for a customized and transparent quote.'
  },
  {
    question: 'Can I customize pickup and drop-off points for my family trip?',
    answer: 'Yes, we offer flexible pickup and drop-off options and can customize the route according to your family’s schedule and travel plan.'
  },
  {
    question: 'Why choose Amruta Travels for renting an Urbania for a family trip?',
    answer: 'Amruta Travels provides well-maintained Urbania vehicles, professional drivers, transparent pricing, and dedicated support, ensuring a safe, comfortable, and enjoyable family travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Pranav Deshmukh',
    role: 'Father, Pune',
    text: 'We rented an Urbania for a family weekend trip. The vehicle was spacious, clean, and comfortable. The driver was courteous and punctual. Amruta Travels made our trip stress-free and enjoyable!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Meera Patil',
    role: 'Mother, Pune',
    text: 'Booked an Urbania for a family vacation. The ride was smooth, the vehicle was luxurious, and the driver was very professional. Highly recommend Amruta Travels for family trips!',
    rating: 5
  }
];

















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Pune for Family Trip",
  "image": "https://bushireinpune.com/assets/images/urbania-family-trip-pune.jpg",
  "description": "Hire Urbania on rent in Pune for family trips with Amruta Travels. Luxury AC Force Urbania vans available in 13 and 17 seater options for family travel, tours, and weekend getaways. Service available across Baner, Kharadi, Hadapsar, Hinjewadi, Wakad, Kothrud, Pimpri Chinchwad, Nigdi, and Pune city. Perfect for trips to Lonavala, Mahabaleshwar, Shirdi, and other outstation destinations, with professional drivers and affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6300",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-on-rent-pune-for-family-trip"
  }
};


    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Urbania on Rent in Pune for Family Trip | Amruta Travels</title>
  <meta
    name="description"
    content="Urbania on rent in Pune for family trips with Amruta Travels. Luxury 13 & 17 seater Force Urbania vans for family travel, weekend getaways, and outstation trips to Lonavala, Mahabaleshwar, Shirdi & more."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/104.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinpuneforfamily;